
import React, { memo, useState } from "react";
import {
  Grow,
  Tooltip,
  useTheme
} from "@material-ui/core";

export const ArrowTooltip = (props) => {
  return (
    <Tooltip
      arrow
      {...props}
    >
      {props.children}
    </Tooltip>
  );
};

export const CursorTooltip = memo((props: any) => {
  const {textLines} = props;

  const theme = useTheme();

  const [position, setPosition] = useState({
    x: undefined,
    y: undefined
  });

  const title = textLines.map((line, index) => (
    <React.Fragment key={index}>
      {(index !== 0) && (<br/>)}
      {line}
    </React.Fragment>
  ));

  const visible = (textLines.length > 0)
    && (position.x !== undefined);

  const {enteringScreen} = theme.transitions.duration;

  const transitionProps = {
    timeout: {
      enter: enteringScreen,
      exit: 0
    }
  };

  return (
    <Tooltip
      arrow
      open={visible}
      title={title}
      placement="right"
      onClose={() => {
        setPosition({
          x: undefined,
          y: undefined
        });
      }}
      onMouseMove={(event) => {
        setPosition({
          x: event.pageX,
          y: event.pageY
        });
      }}
      TransitionComponent={Grow}
      TransitionProps={transitionProps}
      PopperProps={{
        anchorEl: {
          clientHeight: 0,
          clientWidth: 0,
          getBoundingClientRect: () => ({
            top: position.y,
            left: position.x,
            right: position.x,
            bottom: position.y,
            width: 0,
            height: 0
          } as any)
        }
      }}
    >
      {props.children}
    </Tooltip>
  );
});